export default class CurrentModule {
  /**
   * 
   * @param {Object} Vue
   * @param {Object} Vue.prototype
   * @param {import('./Company').default} Vue.prototype.$company
   */
  constructor(Vue) {
    this.module = Vue.prototype.$company.moduleOpen;
    this.item = Vue.prototype.$company.itemOpen;
  }
}
